(() => {
  if (customElements.get('featured-articles-carousel')) {
    return;
  }

  class FeaturedArticlesCarousel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.initElements();
        this.initSlider();
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }

    initElements() {
      this.slider = null;
      this.options = {
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        pagination: {
          el: this.querySelector('[data-pagination]'),
          type: 'bullets',
          clickable: true,
          dynamicBullets: true,
        },
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchOverflow: true,
        breakpoints: {
          749: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      };
      this.sliderType = '';
    }

    initSlider() {
      if (!this.querySelector('[data-slider]') && this.slider !== null) return;

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }

    destroySlider() {
      this.slider.destroy();

      this.slider = null;
    }
  }

  customElements.define('featured-articles-carousel', FeaturedArticlesCarousel);
})();
